export const testimonials = [
  {
    id: 1,
    name: 'Robert Williams',
    title: 'CEO, TechVenture Inc.',
    rating: 5,
    text: 'Federal IP Office guided us through a complex merger with exceptional professionalism. Their attention to detail and strategic insight were invaluable.',
  },
  {
    id: 2,
    name: 'Amanda Foster',
    title: 'Founder, Creative Studios',
    rating: 5,
    text: 'The team secured trademark protection for our entire brand portfolio efficiently. Their expertise in IP law is unmatched.',
  },
  {
    id: 3,
    name: 'Marcus Johnson',
    title: 'Director, Global Logistics Corp',
    rating: 5,
    text: 'Outstanding service in government contracting compliance. They made a complex process straightforward and ensured we met all requirements.',
  },
  {
    id: 4,
    name: 'Lisa Chen',
    title: 'COO, BioHealth Solutions',
    rating: 5,
    text: 'Federal IP Office resolved our business dispute efficiently and professionally. Their litigation expertise saved us significant time and resources.',
  },
  {
    id: 5,
    name: 'David Martinez',
    title: 'President, Manufacturing Alliance',
    rating: 5,
    text: 'From business formation to contract negotiation, their comprehensive legal support has been instrumental in our growth.',
  },
  {
    id: 6,
    name: 'Jennifer Thompson',
    title: 'Executive Director, Community Foundation',
    rating: 5,
    text: 'Their non-profit law expertise helped us navigate complex compliance requirements. Highly recommend their services.',
  },
];
